<template>
    <div>
        <div style="width: 400px; max-width: 100%; margin: auto;">
            <md-field>
                <label>Respondant Level of Training</label>
                <br>
                <md-select v-model="selectedTrainingLevels" multiple>
                    <md-option v-for="level in trainingLevels" :key="level" :value="level">
                        {{trainingLevelsLong[level]}}
                    </md-option>
                </md-select>
            </md-field>
        </div>
        <div class="result-container">
            <div v-if="Object.values(slideDeck).filter(x => slidePerformance[x.id]).length < 1">
                <md-empty-state
                    md-icon="error"
                    md-label="No Data"
                    md-description="We cannot find any relevant response data for this dashboard.">
                </md-empty-state>
            </div>
            <div v-else style="display: flex; flex-wrap: wrap; justify-content: space-around;">
                <span v-for="(slideEntry, slideIndex) in slideDeck" :key="slideIndex" v-if="slidePerformance[slideEntry.id]">
                    <div class="md-card">
                        <h2 style="padding: 8px 20px">
                            Slide #{{slideIndex}} -
                            {{slideEntry.type}}
                        </h2>
                        <hr>
                        <div style="padding: 20px 20px; min-height: 100px">
                            <div v-if="slideEntry.type == 'Multiple Choice'">
                                <md-tabs class="answer-tabs">
                                    <md-tab md-label="Score" md-dynamic-height>
                                        <b v-if="indicatorLookup[slideEntry.id]">
                                            Your Answer:
                                            {{indicatorLookup[slideEntry.id] == 100 ? 'Correct' : 'Incorrect'}}
                                            <br><br>
                                        </b>
                                        <Barplot 
                                            :score-data="slidePerformance[slideEntry.id].map((x) => x.score == 100 ? 'Correct' : 'Incorrect')" 
                                            :score-indicator="indicatorLookup[slideEntry.id] ? (indicatorLookup[slideEntry.id] == 100 ? 'Correct' : 'Incorrect') : undefined"
                                            :color-palette="{'Correct': '#33a00b', 'Incorrect': '#a0240b'}"
                                        />
                                    </md-tab>
                                    <md-tab md-label="Top Responses">
                                        <div class="answer-list">
                                            <div v-for="(entry, answerIndex) in aggregateMultipleChoice(slideEntry.id, slideDeck[slideIndex])" :key="answerIndex"
                                            class="answer-list-entry">
                                                {{entry.count}} x 
                                                <span class="answer-list-corpus">
                                                    {{entry.corpus}}
                                                </span>
                                            </div>
                                        </div>
                                    </md-tab>
                                </md-tabs>
                            </div>
                            <div v-else-if="slideEntry.type == 'Checklist'">
                                <md-tabs class="answer-tabs">
                                    <md-tab md-label="Score" md-dynamic-height>
                                        <Histogram 
                                            :score-data="slidePerformance[slideEntry.id].map((x) => x.score)" 
                                            :score-indicator="indicatorLookup[slideEntry.id]"
                                            :xmin="0"
                                            :xmax="100"
                                        />
                                    </md-tab>
                                    <md-tab md-label="Top Responses">
                                        <div class="answer-list">
                                            <div v-for="(entry, answerIndex) in aggregateChecklist(slideEntry.id, slideDeck[slideIndex])" :key="answerIndex"
                                            class="answer-list-entry">
                                                {{entry.count}} x 
                                                <span class="answer-list-corpus">
                                                    {{entry.corpus}}
                                                </span>
                                            </div>
                                        </div>
                                    </md-tab>
                                </md-tabs>
                            </div>
                            <div v-else-if="slideEntry.type == 'Short Answer'">
                                <md-tabs class="answer-tabs">
                                    <md-tab md-label="Word Cloud" md-dynamic-height>
                                        <Wordcloud
                                        :data="shortAnswerCloudCounts(slideEntry.id)"
                                        :showTooltip="false"
                                        :rotate="{'from': 0, 'to': 0}"
                                        :margin="{top: 0, right: 0, bottom: 0, left: 0}"
                                        class="expando-word-cloud">
                                        </Wordcloud>
                                    </md-tab>
                                    <md-tab md-label="Top Responses">
                                        <div class="answer-list">
                                            <div v-for="(entry, answerIndex) in aggregateShortAnswer(slideEntry.id)" :key="answerIndex"
                                            class="answer-list-entry">
                                                {{entry.count}} x 
                                                <span class="answer-list-corpus">
                                                    {{entry.corpus}}
                                                </span>
                                            </div>
                                        </div>
                                    </md-tab>
                                </md-tabs>
                            </div>
                            <div v-else-if="slideEntry.type == 'Labs'">
                                <md-tabs class="answer-tabs" md-dynamic-height>
                                    <md-tab md-label="Spending">
                                        <div v-if="indicatorLookup[slideEntry.id]" style="font-size: 85%; margin-top: -12px; margin-bottom: -35px; font-weight: bold;">
                                            You spent: ${{indicatorLookup[slideEntry.id].totalCost}} out of ${{indicatorLookup[slideEntry.id].maxCost}}
                                            <br><br>
                                        </div>
                                        <Histogram class="tab-plot"
                                            :score-data="slideCostPerformance[slideEntry.id]" 
                                            :score-indicator="indicatorLookup[slideEntry.id] ? (100*indicatorLookup[slideEntry.id].totalCost / indicatorLookup[slideEntry.id].maxCost) : undefined"
                                            :xmin="0"
                                            :xmax="100"
                                            xlab="Percentage Spent of Total Cost"
                                            fill-color="#33a00b"
                                        /> 
                                    </md-tab>
                                    <md-tab md-label="Score">
                                        <Histogram class="tab-plot"
                                            :score-data="slidePerformance[slideEntry.id].map((x) => x.score)"
                                            :score-indicator="indicatorLookup[slideEntry.id] ? indicatorLookup[slideEntry.id].score : undefined"
                                            :xmin="0"
                                            :xmax="100"
                                        />
                                    </md-tab>
                                </md-tabs>
                            </div>
                            <div v-else-if="slideEntry.type == 'Diagnosis'">
                                <md-tabs class="answer-tabs" md-dynamic-height>
                                    <md-tab md-label="Score"
                                    v-if="slidePerformance[slideEntry.id].filter((x) => typeof x.score === 'number').length > 0">
                                        <Histogram class="tab-plot"
                                            :score-data="slidePerformance[slideEntry.id].filter((x) => typeof x.score === 'number').map((x) => x.score)"
                                            :score-indicator="indicatorLookup[slideEntry.id]"
                                            :xmin="0"
                                            :xmax="100"
                                        />
                                    </md-tab>
                                    <md-tab md-label="Dx Rankings">
                                        <div style="max-height: 220px; overflow-y: auto; margin-top: -20px;">
                                            <hr style="margin-top: 4px;">
                                            <div v-for="(dxCounts, dxLabel) in aggregateDiagnosis(slideEntry.id)" :key="dxLabel">
                                                <b>{{dxLabel}}</b>
                                                <hr>
                                                <div v-for="(dxData, dxIndex) in dxCounts" :key="dxIndex">
                                                    {{dxData.count}} x {{dxData.dx}}
                                                </div>
                                                <hr>
                                            </div>
                                        </div>
                                    </md-tab>
                                    <md-tab md-label="Top Dx">
                                        <b style="margin-top: -12px; display: block; font-size: 90%;">
                                            Why did you pick your top diagnosis?
                                        </b>
                                        <Wordcloud
                                            :data="diagnosisCloudCounts(slideEntry.id)"
                                            :showTooltip="false"
                                            :rotate="{'from': 0, 'to': 0}"
                                            :fontSize="[10, 30]"
                                            :margin="{top: 0, right: 0, bottom: 0, left: 0}"
                                            class="expando-word-cloud"
                                            style="height: 200px;">
                                        </Wordcloud>
                                    </md-tab>
                                </md-tabs>
                            </div>
                            <div v-else>
                                <Histogram 
                                    :score-data="slidePerformance[slideEntry.id].map((x) => x.score)" 
                                    :score-indicator="indicatorLookup[slideEntry.id]"
                                    :xmin="0"
                                    :xmax="100"
                                />
                            </div>
                        </div>
                    </div>
                </span>
                <span>
                    <div class="md-card">
                        <h2 style="padding: 8px 20px">
                            Time on Case
                        </h2>
                        <hr>
                        <div style="padding: 20px 20px; min-height: 100px">
                            <Histogram 
                                :score-data="aggregateTimeElapsed" 
                                :score-indicator="myTimeElapsed"
                                :xmin="0"
                                xlab="Time (min)"
                            />
                        </div>
                    </div>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import Barplot from "../plotting/Barplot.vue"
    import Histogram from "../plotting/Histogram.vue"
    import Wordcloud from 'vue-wordcloud'

    export default {
        components: {
            Barplot,
            Histogram,
            Wordcloud
        },
        props: {
            slideDeck: {
                type: Object
            },
            responseData: {
                type: Array
            },
            indicatorData: {
                type: Array 
            },
        },
        data: function(){
            return {
                slidePerformance: {},
                slideCostPerformance: {},
                trainingLevels: [],
                selectedTrainingLevels: [],
                trainingLevelsLong: {
                    "pm": "Pre-medical Student",
                    "ms": "Medical School",
                    "do": "DO School",
                    "pgy": "Residency",
                    "fel": "Fellowship",
                    "att": "Attending",
                    "other": "Other",
                    "unk": "Unknown"
                }
            }
        },
        watch: {
            "responseData": function(){
                this.trainingLevels = Array.from(new Set(this.responseData.map((responseEntry) => {
                    return responseEntry.training.level
                }))).map((lvl) => {
                    return Object.keys(this.trainingLevelsLong).includes(lvl) ? lvl : "unk"
                }).sort()
                this.selectedTrainingLevels = JSON.parse(JSON.stringify(this.trainingLevels));
            },
            "selectedTrainingLevels": function(){
                this.aggregateSlideResponses()
            },
        },
        methods: {
            wordCloudCount: function(wordArray, maxResults){
                let filterWords = ["hx", "pt", "patient" ]
                filterWords += ["a", "able", "about", "across", "after", "all", "almost", "also", "am", "among", "an", "and", "any", "are", "as", "at", "be", "because", "been", "but", "by", "can", "cannot", "could", "dear", "did", "do", "does", "either", "else", "ever", "every", "for", "from", "get", "got", "had", "has", "have", "he", "her", "hers", "him", "his", "how", "however", "i", "if", "in", "into", "is", "it", "its", "just", "least", "let", "like", "likely", "may", "me", "might", "most", "must", "my", "neither", "no", "nor", "not", "of", "off", "often", "on", "only", "or", "other", "our", "own", "rather", "said", "say", "says", "she", "should", "since", "so", "some", "than", "that", "the", "their", "them", "then", "there", "these", "they", "this", "tis", "to", "too", "twas", "us", "wants", "was", "we", "were", "what", "when", "where", "which", "while", "who", "whom", "why", "will", "with", "would", "yet", "you", "your", "ain't", "aren't", "can't", "could've", "couldn't", "didn't", "doesn't", "don't", "hasn't", "he'd", "he'll", "he's", "how'd", "how'll", "how's", "i'd", "i'll", "i'm", "i've", "isn't", "it's", "might've", "mightn't", "must've", "mustn't", "shan't", "she'd", "she'll", "she's", "should've", "shouldn't", "that'll", "that's", "there's", "they'd", "they'll", "they're", "they've", "wasn't", "we'd", "we'll", "we're", "weren't", "what'd", "what's", "when'd", "when'll", "when's", "where'd", "where'll", "where's", "who'd", "who'll", "who's", "why'd", "why'll", "why's", "won't", "would've", "wouldn't", "you'd", "you'll", "you're", "you've"]
                return Object.values(wordArray.reduce((aggregator, wordEntry) => {
                    if(filterWords.includes(wordEntry)) return aggregator
                    if(wordEntry.length < 3) return aggregator
                    if(aggregator[wordEntry] == undefined) aggregator[wordEntry] = {"name": wordEntry} 
                    aggregator[wordEntry].value = (aggregator[wordEntry].value || 0 ) + 1
                    return aggregator
                }, {})).sort((a, b) => b.value - a.value).slice(0, maxResults)
            },
            shortAnswerCloudCounts: function(slideID, maxResults = 40){
                let wordBlob = this.slidePerformance[slideID].reduce((aggregator, responseEntry) => {
                    return aggregator + " " + responseEntry.score.toLowerCase()
                }, "").replace(/[.,/#!$?%^&*;:{}=\-_`~()\d]/g," ")
                let wordArray = wordBlob.split(/\s+/)
                return this.wordCloudCount(wordArray, maxResults)
            },
            diagnosisCloudCounts: function(slideID, maxResults = 40){   
                let wordBlob = this.slidePerformance[slideID].reduce((aggregator, responseEntry) => {
                    if(responseEntry.performance == undefined || responseEntry.performance.Diagnosis == undefined) return aggregator
                    if(responseEntry.performance.Diagnosis["High Likelihood"].length < 1) return aggregator
                    let explanation = responseEntry.performance.Diagnosis["High Likelihood"][0].explanation
                    if(explanation == undefined) return aggregator
                    return aggregator + " " + explanation
                }, "").replace(/[.,/#!$?%^&*;:{}=\-_`~()\d]/g," ")
                let wordArray = wordBlob.split(/\s+/)
                return this.wordCloudCount(wordArray, maxResults)
            },
            aggregateDiagnosis: function(slideID, maxResults=10){
                let dxCountObj = this.slidePerformance[slideID].reduce((aggregator, responseEntry) => {
                    if(responseEntry.performance == undefined || responseEntry.performance.Diagnosis == undefined) return aggregator
                    Object.keys(responseEntry.performance.Diagnosis).forEach((dxLabel) => {
                        if(aggregator[dxLabel] == undefined) aggregator[dxLabel] = {}
                        responseEntry.performance.Diagnosis[dxLabel].forEach((dxEntry, dxIndex) => {
                            let newLabel = dxLabel
                            if(dxIndex == 0 && dxLabel == "High Likelihood"){
                                newLabel = "Top Diagnosis"
                            }
                            let dx = dxEntry.dx.toLowerCase()
                            if(aggregator[newLabel][dx] == undefined) aggregator[newLabel][dx] = {"dx": dx} 
                            aggregator[newLabel][dx].count = (aggregator[newLabel][dx].count || 0 ) + 1
                        })
                    })
                    return aggregator
                }, {"Top Diagnosis": {}})
                return Object.keys(dxCountObj).reduce((aggregator, dxLabel) => {
                    aggregator[dxLabel] = Object.values(dxCountObj[dxLabel]).sort((a, b) => b.count - a.count).slice(0, maxResults)
                    return aggregator
                }, {})
            },
            aggregateShortAnswer: function(slideID, maxResults = 20){
                return Object.values(this.slidePerformance[slideID].reduce((aggregator, responseEntry) => {
                    if(aggregator[responseEntry.score] == undefined) aggregator[responseEntry.score] = {"corpus": responseEntry.score} 
                    aggregator[responseEntry.score].count = (aggregator[responseEntry.score].count || 0 ) + 1
                    return aggregator
                }, {})).sort((a, b) => b.count - a.count).slice(0, maxResults)
            },
            aggregateChecklist: function(slideID, slideData, maxResults = 20){
                let ckOptLookup = slideData.options.reduce((aggregator, ckOpt) => {
                    aggregator[ckOpt.id] = ckOpt
                    return aggregator
                }, {})
                return Object.values(this.slidePerformance[slideID].reduce((aggregator, responseEntry) => {
                    if(responseEntry.performance == undefined || responseEntry.performance["Checklist"] == undefined) return aggregator
                    let choiceID = responseEntry.performance["Checklist"]
                    if(ckOptLookup[choiceID] == undefined) return aggregator
                    let choiceCorpus = ckOptLookup[choiceID].corpus
                    if(aggregator[choiceCorpus] == undefined) aggregator[choiceCorpus] = {"corpus": choiceCorpus} 
                    aggregator[choiceCorpus].count = (aggregator[choiceCorpus].count || 0 ) + 1
                    return aggregator
                }, {})).sort((a, b) => b.count - a.count).slice(0, maxResults)
            },
            aggregateMultipleChoice: function(slideID, slideData, maxResults = 20){
                let mcLookup = slideData.options.reduce((aggregator, mcOpt) => {
                    aggregator[mcOpt.id] = mcOpt
                    return aggregator
                }, {})
                return Object.values(this.slidePerformance[slideID].reduce((aggregator, responseEntry) => {
                    if(responseEntry.performance == undefined || responseEntry.performance["Multiple Choice"] == undefined) return aggregator
                    let choiceID = responseEntry.performance["Multiple Choice"]
                    if(mcLookup[choiceID] == undefined) return aggregator
                    let choiceCorpus = mcLookup[choiceID].corpus
                    if(aggregator[choiceCorpus] == undefined) aggregator[choiceCorpus] = {"corpus": choiceCorpus} 
                    aggregator[choiceCorpus].count = (aggregator[choiceCorpus].count || 0 ) + 1
                    return aggregator
                }, {})).sort((a, b) => b.count - a.count).slice(0, maxResults)
            },
            aggregateSlideResponses: function(){
                let performance = {}
                this.responseData.filter((responseEntry) => {
                    return this.selectedTrainingLevels.includes(responseEntry.training.level)
                }).forEach((responseEntry) => {
                    if(responseEntry.slideType == "Begin Case") return
                    if(responseEntry.slideType == "Short Answer") {
                        if(responseEntry.performance["Short Answer"] == undefined) return
                        responseEntry.score = responseEntry.performance["Short Answer"]
                    }
                    if(responseEntry.slideType == "Diagnosis" && responseEntry.score == undefined) {
                        if(responseEntry.performance.Diagnosis == undefined) return
                        let highLikelihoodDx = responseEntry.performance.Diagnosis["High Likelihood"]
                        if(!(highLikelihoodDx && highLikelihoodDx.length > 0)) return
                        responseEntry.score =  highLikelihoodDx[0].dx
                    }
                    if(responseEntry.score == undefined) return
                    if(!performance[responseEntry.sid]) performance[responseEntry.sid] = []
                    performance[responseEntry.sid].push(responseEntry)
                    if(responseEntry.performance.Labs && responseEntry.performance.Labs.totalCost && responseEntry.performance.Labs.maxCost){
                        if(!this.slideCostPerformance[responseEntry.sid]) {
                            this.slideCostPerformance[responseEntry.sid] = []
                        }
                        this.slideCostPerformance[responseEntry.sid].push(100*responseEntry.performance.Labs.totalCost/responseEntry.performance.Labs.maxCost)
                    }
                })
                this.slidePerformance = performance
            },
        },
        computed: {
            aggregateTimeElapsed: function() {
                const timePairs = {};
                this.responseData.forEach((responseEntry) => {
                    // Create data structure
                    if (!timePairs[responseEntry.pid]) timePairs[responseEntry.pid] = {}
                    if (!timePairs[responseEntry.pid][responseEntry.attempt]) timePairs[responseEntry.pid][responseEntry.attempt] = {start: undefined, end: undefined}
                    // Fill in start/end times
                    if (responseEntry.slideType == "Begin Case") timePairs[responseEntry.pid][responseEntry.attempt].start = responseEntry.finishTime
                    if (responseEntry.last_slide === true) timePairs[responseEntry.pid][responseEntry.attempt].end = responseEntry.finishTime
                })
                return Object.values(timePairs).map((attemptMap) => {
                    return Object.values(attemptMap).filter((pair) => pair.start && pair.end).map((pair) => (pair.end - pair.start) / 60)
                }).flat()
            },
            myTimeElapsed: function() {
                if(!this.indicatorData) return undefined
                const timePair = {start: undefined, end: undefined};
                this.indicatorData.forEach((responseEntry) => {
                    // Fill in start/end times
                    if (responseEntry.slideType == "Begin Case") timePair.start = responseEntry.finishTime
                    if (responseEntry.last_slide === true) timePair.end = responseEntry.finishTime
                })
                return (timePair.start && timePair.end) ? ((timePair.end - timePair.start) / 60) : undefined;
            },
            indicatorLookup: function(){
                if(!this.indicatorData) return {}
                return this.indicatorData.reduce((aggregator, indicatorEntry) => {
                    if(indicatorEntry.score == undefined) return aggregator
                    if(indicatorEntry.slideType == "Labs") {
                        aggregator[indicatorEntry.sid] = {
                            score: indicatorEntry.score,
                            totalCost: indicatorEntry.performance.Labs.totalCost,
                            maxCost: indicatorEntry.performance.Labs.maxCost
                        }
                        return aggregator
                    }
                    aggregator[indicatorEntry.sid] = indicatorEntry.score
                    return aggregator
                }, {})
            },
        },
    }
</script>

<style scoped>
    .result-container{
        width: 100%;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
    }
    .md-card{
        display: inline-block;
        margin: 23px 10px;
    }
    .answer-tabs{
        margin-top: -20px;
        max-width: 340px;
    }
    .answer-tabs >>> .md-tabs-navigation .md-button-content{
        font-size: 80%;
    }
    .answer-tabs >>> .md-tabs-navigation .md-button{
        height: 30px;
    }
    .answer-tabs >>> .md-tab {
        padding: 0;
        margin-top: 20px;
    }
    .answer-tabs >>> .md-tabs-content{
        height: auto !important;
    }
    .answer-list{
        max-width: 340px;
        margin-top: -20px;
        max-height: 230px;
        overflow-y: auto;
        border: 1px solid #ccc; 
        border-bottom: none;
        padding-bottom: 0px;
    }
    .answer-list-entry {
        border-bottom: 1px solid #ccc; 
        margin-bottom: 5px; 
        padding: 8px 10px;
        text-align: left;
    }
    .answer-list-corpus { 
        max-width: 260px;
        max-height: 60px;
        overflow: hidden;
        word-break: break-word;
        display: inline-block;
        vertical-align: middle;
        margin: 0 5px;
        padding: 0 5px;
        border-left: 1px solid #ddd;
    }
    .answer-list-corpus:hover { 
        max-height: 200px;
    }
    .expando-word-cloud{
        width: 340px; 
        height: 210px;
        margin-bottom: 0px;
    }
    .tab-plot {
        margin-top: -20px;
        margin-bottom: 10px;
    }
</style>

